import { Logo, useDocumentTitle } from "@unizpay/ui";
import { isRouteErrorResponse, useRouteError } from "react-router";

/**
 * Shown instead of a page that crashed while rendering or loading. Users get a way out (reload
 * or go home); the technical message is only shown in development.
 */
export function RouteErrorPage() {
  const error = useRouteError();
  useDocumentTitle("Something went wrong");
  const detail = isRouteErrorResponse(error)
    ? `${error.status} ${error.statusText}`
    : error instanceof Error
      ? error.message
      : String(error);

  return (
    <div className="flex min-h-dvh flex-col items-center justify-center px-4 py-10">
      <Logo className="mb-8 h-9" />
      <main className="w-full max-w-sm rounded-lg border border-line bg-surface px-6 py-7 text-center shadow-sm">
        <h1 className="text-lg font-semibold">Something went wrong</h1>
        <p className="mt-1.5 text-[0.8125rem] text-fg-muted">
          This page could not be displayed. Reloading usually fixes it; your data is safe.
        </p>
        {import.meta.env.DEV && (
          <pre className="mt-4 max-h-40 overflow-auto rounded-md bg-subtle px-3 py-2 text-left font-mono text-xs whitespace-pre-wrap text-danger">
            {detail}
          </pre>
        )}
        <div className="mt-6 flex flex-col gap-2">
          <button
            type="button"
            onClick={() => window.location.reload()}
            className="inline-flex h-10 w-full items-center justify-center rounded-md bg-accent px-4 text-sm font-medium text-accent-fg shadow-sm hover:bg-accent-hover"
          >
            Reload
          </button>
          <a
            href="/dashboard"
            className="inline-flex h-10 w-full items-center justify-center rounded-md border border-line-strong px-4 text-sm font-medium hover:bg-subtle"
          >
            Go to dashboard
          </a>
        </div>
      </main>
    </div>
  );
}
